export default __webpack_public_path__ + "static/media/Tiana 2_9781408350843.198ec459.jpg";